import React, {Component} from 'react'
import {CSSTransition, TransitionGroup} from 'react-transition-group'
import CloseBtn from '../../components/CloseBtn'
import InnerWrap from './WrapLocation'
import MapSection from '../../components/MapSection'
import BackSound from '../../components/BackSound'
import * as routes from '../../const/routes'
import * as videos from '../../const/videos'
import {withUiContext} from "../../UiContext";
import MenuBtn from "../../components/MenuBtn";
import NavContent from "../../components/NavContent";
import {getLabelPositionForMapPoint} from "../../lib/utils";
import MapProjectPoint from "../../components/MapSection/MapProjectPoint";
import Languages from '../../const/languages'

import { loadingLocationData } from '../../lib/utils'

const locationId = 4;

class Location4 extends Component {

    state = {
        driver: this.props.ui.driver,
        navContent: false,
        thisLocation: null,
        thisProjects: null,
        popup: {
            type: null,
            opened: false,
            data: null,
        },
        currentProject: null,
    }

    toggleNav = (e) => {
        this.setState((prevState) => ({navContent: !prevState.navContent}))
    }

    onEnded = () => {
        this.setState({driver: false})
    }

    popupCloseHandler = () => {
        this.setState({
            popup: {
                classSfx: null,
                opened: false,
                data: null,
            }
        })
    }

    popupOpenHandler = (data, classSfx) => {
        this.setState({
            popup: {
                classSfx,
                opened: true,
                data,
            }
        })
    }
    
    setCurrentProject = (currentProject) => {
        this.setState({
            currentProject
        })
    }

    render() {
        const { driver, navContent, popup } = this.state;
        const { thisLocation, thisProjects } = loadingLocationData(locationId);

        return (
            <InnerWrap
                video={videos[`map_${locationId}zoom`]}
                driverVideo={videos[`map_perehod${locationId}`]}
                title={!driver && thisLocation === null && Languages.projects}
                popup={popup}
                popupOpenHandler={this.popupOpenHandler}
                popupCloseHandler={this.popupCloseHandler}
                onEnded={this.onEnded}
                driver={driver}
                currentProject={this.state.currentProject}
            >
                <div className="hud__container-content">
                    {!driver && (
                        <MenuBtn className={`animated ${!navContent ? 'fadeInLeft' : 'fadeOutLeft'}`} onClick={this.toggleNav} onMouseEnter={this.props.ui.playOverSound}/>
                    )}

                    <TransitionGroup className="menu-outer">
                        {navContent && (
                            <CSSTransition timeout={300} classNames="menu-transition">
                                <NavContent onClose={this.toggleNav}/>
                            </CSSTransition>
                        )}
                    </TransitionGroup>

                    { !driver && thisLocation && (
                        <MapSection>
                            { thisProjects && thisProjects.map((item, index) => {
                                const { id, name, coordinates, labelPositionNumber, point } = item;
                                const className = getLabelPositionForMapPoint(labelPositionNumber)

                                return (
                                    <MapProjectPoint
                                        key={index}
                                        label={name}
                                        className={`${className} hud-map__point-${id}`}
                                        style={{
                                            left: coordinates.x,
                                            top: coordinates.y,
                                        }}
                                        point={point}
                                        onClick={() => {
                                            this.popupOpenHandler(item, 'project');
                                            this.setCurrentProject(item);
                                        }}
                                    />
                                )
                            })}
                        </MapSection>
                    )}
                </div>

                <div className="hud__container-controls">
                    {!driver && <BackSound navContent={navContent} />}

                    <CloseBtn
                        link={routes.PROJECT}
                        driverStatus
                    />
                </div>
            </InnerWrap>
        )
    }
}

export default withUiContext(Location4)
